import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';

import { userApi } from '../user/api';
import { authApi } from './api';
import { AuthState } from './types';
import { resetOnLogOutMatcher } from './utils';

const initialState: AuthState = {
  accessToken: '',
  refreshToken: '',
  mustSetPassword: false,
  privacyPolicyAccepted: false,
  rememberMe: false,
};

export const authSlice = createSlice({
  extraReducers: (builder) =>
    builder
      .addMatcher(authApi.endpoints.logIn.matchFulfilled, (state, action) => ({
        ...state,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        mustSetPassword: action.payload.mustSetPassword,
        privacyPolicyAccepted: action.payload.privacyPolicyAccepted,
      }))
      .addMatcher(
        isAnyOf(
          authApi.endpoints.logIn.matchRejected,
          userApi.endpoints.myProfile.matchRejected,
        ),
        () => initialState,
      )
      .addMatcher(authApi.endpoints.acceptPrivacyPolicy.matchFulfilled, (state) => ({
        ...state,
        privacyPolicyAccepted: true,
      }))
      .addMatcher(...resetOnLogOutMatcher(initialState)),
  initialState,
  name: 'auth',
  reducers: {
    rememberMe: (state, action: PayloadAction<boolean>) => ({
      ...state,
      rememberMe: action.payload,
    }),
    ssoLogin: (state, action: PayloadAction<{ accessToken: string; refreshToken: string; mustSetPassword: boolean; privacyPolicyAccepted: boolean }>) => ({
      ...state,
      accessToken: action.payload.accessToken,
      refreshToken: action.payload.refreshToken,
      mustSetPassword: action.payload.mustSetPassword,
      privacyPolicyAccepted: action.payload.privacyPolicyAccepted,
    }),
    setAccessToken: (state, action: PayloadAction<string>) => ({
      ...state,
      accessToken: action.payload,
    }),
    logout: () => initialState,
  },
});

export const { rememberMe, ssoLogin, setAccessToken, logout } = authSlice.actions;
